import React from 'react';
import './UserTable.css';

/**
 * User Table Component
 * Displays users in a responsive table format
 */
const UserTable = ({ users, onAddToGroup, loading }) => {
  // Extract user information from user object
  const getUserInfo = (user) => {
    return {
      uid: user.uid || 'N/A',
      email: user.email || 'N/A',
      firstName: user.firstName || '',
      lastName: user.lastName || '',
      fullName: user.commonName || 'N/A',
      // Assuming department, title, and phone are not available in UserInfo
      department: 'N/A',
      title: 'N/A',
      phone: 'N/A'
    };
  };

  if (users.length === 0) {
    return (
      <div className="no-users-message">
        <div className="empty-state">
          <i className="fas fa-users fa-3x text-muted"></i>
          <h5>No Users Found</h5>
          <p className="text-muted">
            {loading ? 'Loading users...' : 'No users match your search criteria.'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="user-table-container">
      <div className="table-responsive">
        <table className="table table-hover user-table">
          <thead className="table-header">
            <tr>
              <th scope="col">User ID</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Department</th>
              <th scope="col">Title</th>
              <th scope="col">Phone</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => {
              const userInfo = getUserInfo(user);
              return (
                <tr key={index} className="user-row">
                  <td className="user-uid">
                    <span className="uid-badge">{userInfo.uid}</span>
                  </td>
                  <td className="user-name">
                    <div className="name-container">
                      <div className="full-name">{userInfo.fullName}</div>
                      {userInfo.firstName && userInfo.lastName && (
                        <div className="name-parts">
                          {userInfo.firstName} {userInfo.lastName}
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="user-email">
                    <a href={`mailto:${userInfo.email}`} className="email-link">
                      {userInfo.email}
                    </a>
                  </td>
                  <td className="user-department">{userInfo.department}</td>
                  <td className="user-title">{userInfo.title}</td>
                  <td className="user-phone">
                    {userInfo.phone !== 'N/A' ? (
                      <a href={`tel:${userInfo.phone}`} className="phone-link">
                        {userInfo.phone}
                      </a>
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td className="user-actions">
                    <div className="action-buttons">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => onAddToGroup(user)}
                        disabled={loading}
                        title="Add to Group"
                      >
                        <i className="fas fa-user-plus"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserTable;
